import React, {useEffect} from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  tableCellClasses,
} from '@mui/material'
import {styled} from '@mui/material/styles'

const HeaderTableCell = styled(TableCell)(({theme}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#45338C',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))
const StyledTableRow = styled(TableRow)(({theme}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}))

export default function ParticipantList({list, type}) {
  const pages = Math.ceil(list.length / 15)
  const [page, setPage] = React.useState(1)
  const [pageData, setPageData] = React.useState([])

  const getPageData = () => {
    setPageData(list?.slice((page - 1) * 15, page * 15))
  }
  useEffect(() => {
    getPageData()
  }, [page])

  const getJobRole = item => {
    switch (item.jobRole) {
      case 4:
        return 'Teaching Staff (Classroom)'
      case 8:
        return 'Teaching Staff (Non-classroom)'
      case 16:
        return 'Support Staff (classroom)'
      case 32:
        return 'Support Staff (non-classroom)'
      case 64:
        return 'Middle leader'
      default:
        return 'Senior leader'
    }
  }

  const getYearGroup = item => {
    if (type === 'Students') {
      return item
    }
    return JSON.parse(item)?.join(',')
  }
  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <HeaderTableCell>First Name</HeaderTableCell>
              <HeaderTableCell>Last Name</HeaderTableCell>
              <HeaderTableCell>
                {type === 'Staff' ? 'Job Role' : 'Year Group'}{' '}
              </HeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pageData?.map((item, index) => (
              <StyledTableRow key={index}>
                <TableCell>{item.firstName}</TableCell>
                <TableCell>{item.lastName}</TableCell>
                <TableCell>
                  {type === 'Staff'
                    ? getJobRole(item)
                    : getYearGroup(item.currentYearGrade)}
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
        {pages > 1 && (
          <div className="pagination">
            {Array.from({length: pages}, (_, i) => (
              <div
                className="page-no"
                style={{
                  color: page === i + 1 ? '#ffffff' : '#000000',
                  backgroundColor: page === i + 1 ? '#53B5E0' : '#EDE7F6',
                }}
                key={i}
                onClick={() => setPage(i + 1)}
              >
                {i + 1}
              </div>
            ))}
          </div>
        )}
      </TableContainer>
    </>
  )
}
